export default __webpack_public_path__ + "static/media/reportSingleIcon.f6d7f255.svg";